import { KeycloakConfig } from 'keycloak-angular';

export const environment = {
    production: false,
    maxSizeUploadFile: 15242880,
    reCaptchaSikeKey: '6Lc24LcUAAAAAOoi9E41fLK-PPC8x0Tdnp8vuZP5',
    pollingNotificationPeriod: 2000
};
